module.exports = "<div>\n    <slot v-if=\"authorized()\"></slot>\n</div>\n"